import * as d3 from 'd3';

export interface TimelineUnitConfig {
  formatAxis: (value: number) => string;
  formatSelection: (value: Date) => string;
  // the width in pixels that the labels
  // occupies, we use this to calculate how many
  // labels to show
  width: number;
  count: (range: Array<Date>) => number;
}

export const timeUnitConfig: (step: string) => TimelineUnitConfig = (step) => {
  const stepsDefinitions = {
    day: {
      formatAxis: d3.timeFormat('%b %d, %y'),
      formatSelection: d3.timeFormat(`%b %d`),
      width: 70,
      count: ([startDate, endDate]) => d3.utcDay.count(startDate, endDate)
    },
    week: {
      formatAxis: d3.timeFormat('W%V/%y'),
      formatSelection: d3.timeFormat(`%b %d`),
      width: 70,
      count: ([startDate, endDate]) => d3.utcWeek.count(startDate, endDate)
    },
    month: {
      formatAxis: d3.timeFormat('%b  %y'),
      formatSelection: d3.timeFormat(`%b '%y`),
      width: 50,
      count: ([startDate, endDate]) => d3.utcMonth.count(startDate, endDate)
    },
    year: {
      formatAxis: d3.timeFormat('%Y'),
      formatSelection: d3.timeFormat(`%b '%y`),
      width: 35,
      count: ([startDate, endDate]) => d3.utcYear.count(startDate, endDate)
    }
  };

  return stepsDefinitions[step];
};
